module.exports = __webpack_public_path__ + "img/default_profile.52292c62.jpg";